import React from "react";

import Project1 from "../assets/project1.png";
import Project2 from "../assets/project2.png";
import Project3 from "../assets/project3.png";
import Project4 from "../assets/project5.png";
import Project from "./Project";

function Projects() {
  return (
    <div className="container mx-auto pt-32 pb-32" id="projects" style={{ minHeight: 'calc(100vh - 72px)' }}>
      <h2 className="text-3xl text-center mb-8">
        Projects
      </h2>
      <h6 className="text-center text-gray-500 animate-pulse">hover for tech</h6>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        <Project projectName={Project1} projectTitle='CloudPizza' projectDesc='CloudPizza is a full-stack website that allows users to order pizza online.' projectLink='https://github.com/emrhngngr/CloudPizza' projectTags={['HTML', 'CSS', 'JS', 'PHP', 'Jquery', 'AJAX', 'Bootstrap', 'MySQL']}/>
        <Project projectName={Project4} projectTitle='InventoryCore' projectDesc='ISO 27001 Compliant Inventory Management System' projectLink='https://github.com/emrhngngr/InventoryCore' projectTags={['HTML', 'CSS', 'JS', 'React', 'TailwindCSS', 'Express.js', 'Node.js', 'JWT', 'MongoDB']}/>
        <Project projectName={Project2} projectTitle='NextFilm' projectDesc='I made this project while trying to learn Next.js.' projectLink='https://emrhnnextfilm.netlify.app' projectTags={['HTML', 'CSS', 'JS', 'Next.js', 'TailwindCSS']}/>
        <Project projectName={Project3} projectTitle="The World's Hardest Game" projectDesc="This is a Java-based recreation of the classic The World's Hardest Game." projectLink='https://github.com/emrhngngr/worldshardestgamejava' projectTags={['Java', 'MySQL', 'Java Swing']}/>
      </div>
    </div>
  );
}

export default Projects;
